export const DEVICE_STATUS_PENDING = 'PENDING';
export const DEVICE_STATUS_APPROVED = 'APPROVED';
export const DEVICE_STATUS_REVOKED = 'REVOKED';

export const STATUS_DEVICE_RESTRICTED = 'DEVICE RESTRICTED';
export const STATUS_DEVICE_PENDING = 'DEVICE PENDING';
